import * as React from 'react';
import clsx from 'clsx';
import { Check } from 'lucide-react';
import { Button, Icon, Typography } from '@/components/common';
import { CaseDetailsEmptyStateProps } from '@/interfaces';

export const CaseDetailsEmptyState: React.FC<CaseDetailsEmptyStateProps> = ({
	icon,
	iconSize,
	iconClassName = 'text-primary',
	titleType,
	title,
	text,
	action,
	className,
}) => {
	return (
		<div
			className={clsx(
				'flex flex-col items-center justify-center gap-[18px] rounded-2xl border border-dashed border-[#8039DF2B] bg-grey-2 px-6 py-8 text-center max-lg:h-[280px]',
				className
			)}
		>
			<div className="flex flex-col items-center gap-4">
				<div
					aria-hidden="true"
					className="relative flex h-16 w-16 items-center justify-center rounded-[20px] border-[0.8px] border-[#8039DF1F] bg-[#8039DF17]"
				>
					<span
						className={clsx(iconClassName, {
							'h-6 w-6': iconSize === 'sm',
							'h-7 w-7': iconSize === 'md',
						})}
					>
						<Icon src={icon} />
					</span>
					<span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border-[2.4px] border-white bg-primary">
						<Check className="h-3 w-3 text-white" strokeWidth={3} />
					</span>
				</div>
				<div className="flex flex-col items-center gap-1.5">
					<Typography type={titleType} className="break-words">
						{title}
					</Typography>
					<Typography
						type="regular-12"
						className="max-w-sm break-words !text-[#77717C]"
					>
						{text}
					</Typography>
				</div>
			</div>
			{action && (
				<Button
					decoration="line-primary"
					size="small"
					className="!w-auto"
					label={action.label}
					onClick={action.onClick}
				/>
			)}
		</div>
	);
};
